import React from 'react';

import styles from './InvoiceDescriptionValue.module.css';

const InvoiceDescriptionValue = (value: string) => <span className={styles.invoiceDescr}>{value}</span>;

export default InvoiceDescriptionValue;
